// Marka Portalı API çağrıları (routes/marka_portal.py). Bearer başlığını utils/apiAuth ekler.
import axios from 'axios';
import { API_BASE_URL } from '../../utils/config';

const KOK = `${API_BASE_URL}/marka-portal`;

/** Portal iframe adresi: her zaman sayfanın KENDİ kökeninden (erp./fedora./dev. hepsi /api/'yi
 *  backend'e yönlendiriyor). Aynı köken şart: portal oturum anahtarını localStorage'dan okur. */
export const portalAdresi = ({ taslak = false, tema, slug } = {}) => {
  const yerel = /^(localhost|127\.)/.test(window.location.hostname);
  const kok = yerel ? KOK : `${window.location.origin}/api/marka-portal`;
  const q = new URLSearchParams();
  if (taslak) q.set('taslak', '1');
  if (tema) q.set('tema', tema);
  return `${kok}/sayfa${q.toString() ? `?${q}` : ''}${slug ? `#${slug}` : ''}`;
};

/** Hata gövdesinden okunur mesaj (yayınla 400'ü {mesaj, zorunlu[]} döner). */
export const hataMesaji = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || 'İşlem başarısız.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join('; ');
  if (d.zorunlu) return `${d.mesaj} ${d.zorunlu.join(' · ')}`;
  return JSON.stringify(d);
};

const veri = (p) => p.then((r) => r.data);

export const markaApi = {
  markalar: () => veri(axios.get(`${KOK}/yonetim/markalar`)),
  marka: (slug) => veri(axios.get(`${KOK}/yonetim/marka/${slug}`)),
  ekle: (govde) => veri(axios.post(`${KOK}/yonetim/marka`, govde)),
  guncelle: (slug, govde) => veri(axios.put(`${KOK}/yonetim/marka/${slug}`, govde)),
  pasif: (slug) => veri(axios.delete(`${KOK}/yonetim/marka/${slug}`)),
  yayinla: (slug) => veri(axios.post(`${KOK}/yonetim/marka/${slug}/yayinla`)),
  taslagaAl: (slug) => veri(axios.post(`${KOK}/yonetim/marka/${slug}/taslaga-al`)),
  dosyaYukle: (slug, yuva, dosya, etiket) => {
    const fd = new FormData();
    fd.append('yuva', yuva);
    fd.append('dosya', dosya);
    if (etiket) fd.append('etiket', etiket);
    return veri(axios.post(`${KOK}/yonetim/marka/${slug}/dosya`, fd));
  },
  dosyaBosalt: (slug, yuva) => veri(axios.delete(`${KOK}/yonetim/marka/${slug}/dosya`, { params: { yuva } })),
  geriAl: (slug, yuva, sha256) => veri(axios.post(`${KOK}/yonetim/marka/${slug}/dosya/geri-al`, { yuva, sha256 })),
  logoGuncelle: (slug, yonelim, govde) => veri(axios.put(`${KOK}/yonetim/marka/${slug}/logo/${yonelim}`, govde)),
  logoKaldir: (slug, yonelim) => veri(axios.delete(`${KOK}/yonetim/marka/${slug}/logo/${yonelim}`)),
};
